
<template>
	<div>
	<b-card no-body class="mb-1">
		<b-card-header header-tag="header" class="p-0">
		<b-button block v-b-toggle.accordion-vclean-code-search variant="light">
			Busca por Código VClean
		</b-button>
		</b-card-header>
		<b-collapse id="accordion-vclean-code-search"  v-model="accordionVCleanCodeSearchVisible"  @show="accordionVCleanCodeSearchShown" class="mt-1">
		<b-card-body class="p-1 pb-2">
			<b-container fluid>
			<b-row>
				<b-col cols="4" sm="4" md="3" lg="2" xl="2" class="d-flex align-items-center">
				<label class="mb-0" for="input-vclean-code">Código VClean:</label>
				</b-col>
				<b-col cols="8" sm=8 md="9" lg="10" xl="10">
				<vue-bootstrap-typeahead id="input-vclean-code" placeholder="Exemplo: VC10A" v-model="vcleanCode" @keydown.enter="search" :data="vCleanCodes" @hit="search" />
				<!--<b-form-input id="input-vclean-code" type="text" v-model="vcleanCode" @keydown.enter="search"></b-form-input>-->
				</b-col>
			</b-row>
			</b-container>
		</b-card-body>
		</b-collapse>
	</b-card>
	<b-card no-body class="mb-1" v-if="fullPathURL != '/codigovclean'">
		<b-card-header header-tag="header" class="p-0">
		<b-button block v-b-toggle.accordion-competitor-code-search variant="light">
			Busca por Código de Concorrente
		</b-button>
		</b-card-header>
		<b-collapse id="accordion-competitor-code-search" v-model="accordionCompetitorCodeSearchVisible"  @show="accordionCompetitorCodeSearchShown" class="mt-1">
		<b-card-body class="p-1 pb-2">
			<b-container fluid>
			<b-row>
				<b-col cols="5" sm="4" md="4" lg="2" xl="2" class="d-flex align-items-center">
				<label class="mb-0" for="input-competitor-code">Código Concorrente:</label>
				</b-col>
				<b-col cols="7" sm=8 md="8" lg="10" xl="10">
				<vue-bootstrap-typeahead id="input-competitor-code" v-model="competitorCode" :data="competitorCodes" @hit="search" />
				<!--<b-form-input id="input-competitor-code" v-model="competitorCode" @keydown.enter="search" type="text"></b-form-input>-->
				</b-col>
			</b-row>
			</b-container>
		</b-card-body>
		</b-collapse>
	</b-card>
	<b-card no-body class="mb-1" v-if="fullPathURL != '/codigovclean'">
		<b-card-header header-tag="header" class="p-0">
		<b-button block v-b-toggle.accordion-vehicle-search variant="light">
			Busca por Veículo
		</b-button>
		</b-card-header>
		<b-collapse id="accordion-vehicle-search" v-model="accordionVehicleSearchVisible" @show="accordionVehicleSearchShown" class="mt-1">
		<b-card no-body class="mb-1">
			<b-card-header header-tag="header" class="p-0">
			<b-button block v-b-toggle.accordion-brand variant="light" class="subitem">
				{{ selectedBrand || 'MARCA' }}
			</b-button>
			</b-card-header>
			<b-collapse id="accordion-brand">
			<b-card-body>
				<b-list-group>
				<b-list-group-item button
					v-for="(brand, index) in brands"
					v-b-toggle="'accordion-brand'"
					:key="index"
					@click="onSelectedBrand(brand)"
				>
					{{ brand.brand }}
				</b-list-group-item>
				</b-list-group>
			</b-card-body>
			</b-collapse>
		</b-card>
		<b-card no-body class="mb-1">
			<b-card-header header-tag="header" class="p-0">
			<b-button block v-b-toggle.accordion-model variant="light" class="subitem">
				{{ selectedModel || 'MODELO' }}
			</b-button>
			</b-card-header>
			<b-collapse id="accordion-model">
			<b-card-body>
				<b-list-group>
				<b-list-group-item
					button
					v-for="(model, index) in models"
					v-b-toggle="'accordion-model'"
					:key="index"
					@click="onSelectedModel(model)"
				>
					{{ model.model }}
				</b-list-group-item>
				</b-list-group>
			</b-card-body>
			</b-collapse>
		</b-card>
		<b-card no-body class="mb-1">
			<b-card-header header-tag="header" class="p-0">
			<b-button block v-b-toggle.accordion-year variant="light" class="subitem">
				{{ selectedYear.displayValue || 'ANO' }}
			</b-button>
			</b-card-header>
			<b-collapse id="accordion-year">
			<b-card-body>
				<b-list-group>
				<b-list-group-item
					button
					v-for="(year, index) in years"
					v-b-toggle="'accordion-year'"
					:key="index"
					:disabled="!selectedModel"
					@click="onSelectedYear(year)"
				>
					{{ year.displayValue }}
				</b-list-group-item>
				</b-list-group>
			</b-card-body>
			</b-collapse>
		</b-card>
		</b-collapse>
	</b-card>
	<div class="buttons-container">
		<b-button @click="clear()" variant="outline-light" class="button-search">LIMPAR</b-button>
		<b-button @click="search"
		:disabled="!(detailURL && accordionVehicleSearchVisible) && !(vcleanCode && accordionVCleanCodeSearchVisible) && !(competitorCode && accordionCompetitorCodeSearchVisible)"
		variant="outline-light" 
		class="button-search"
		>
			BUSCAR
		</b-button>
	</div>
</div>
</template>
  
<script>
/* eslint-disable */
export default {
	name: 'ProductSearch',
	props: {
		data: Array,
		convertionsData: Array,
		applicationsData: Array,
		vCleanCodes: Array,
		competitorCodes: Array
	},
  
	mounted() {
		this.init(this.data);
		let self = this;
		window.addEventListener('keyup', function(e) {
			if (e.key === 'Enter') {
				self.search();
				self.clear()
			}
		});
	},
  
	data() {
		return {
			accordionVehicleSearchVisible: false,
			accordionVCleanCodeSearchVisible: true,
			accordionCompetitorCodeSearchVisible: false,
			fullPathURL: this.$router.currentRoute.fullPath,
			vcleanCode: '',
			competitorCode: '',
			outputVCleanCode: '',
			detailURL: '',
			selectedBrand: '',
			selectedModel: '',
			selectedYear: {},
			brands: [],
			models: [],
			years: []
		};
	},
	
	watch: {
		'data': function(data) {
			this.init(data);
		}
	},
	
	methods: {
		init: function(data) {
			this.brands = data;
		
			for (const brand of this.brands ) {
				this.models = [ ...this.models, ...brand.models ];
			}
		
			this.years = [ ...this.years, { displayValue: 'Selecione uma marca ou modelo' } ];
		},
		
		onSelectedBrand: function(selected) {
			this.models = [];
			this.selectedModel = '';
			this.selectedBrand = selected.brand;
		
			const filteredBrands = this.brands.filter(item => item.brand === this.selectedBrand);
		
			if (filteredBrands.length) {
				for (const brand of filteredBrands) {
					this.models = [ ...this.models, ...brand.models ];
				}
			}
		},
		
		onSelectedModel: function(selected) {
			this.years = [];
			this.selectedModel = selected.model;
		
			const filteredBrand = this.brands.find(function(item) {
				for (const model of item.models) {
					if (model.model === selected.model) {
						return model;
					}
				}
			});
		
			if (filteredBrand) {
				this.selectedBrand = filteredBrand.brand;
			}
		
			if (selected.items.length) {
				for (const year of selected.items) {
					const modifiedYear = { 
						brand: this.selectedBrand, 
						model: this.selectedModel,
						displayValue: `DE: ${year.from} ATÉ: ${year.to}`,
						...year
					};
					this.years = [ ...this.years, modifiedYear ];
				}
			}
		},
		
		onSelectedYear: function(selected) {
			this.selectedYear = selected;
		
			const normalizedBrand = this.selectedBrand.replace(new RegExp(/\//, 'g'), '%2F');
			const normalizedModel = this.selectedModel.replace(new RegExp(/\//, 'g'), '%2F');
			this.detailURL = `/brand/${normalizedBrand}/model/${normalizedModel}/year/${this.selectedYear.from}-${this.selectedYear.to}`;
		},
  
		search: function() {
			if (this.accordionVehicleSearchVisible) {
				this.$router.push(this.detailURL);
				return;
			}
  
			if (this.accordionVCleanCodeSearchVisible && this.fullPathURL != '/codigovclean') {
				if (this.vcleanCode) {
					this.$router.push(`/applications/${this.vcleanCode}`);
					return;
				}
			}
			else if (this.accordionVCleanCodeSearchVisible && this.fullPathURL == '/codigovclean') {
				if (this.vcleanCode) {
					this.$router.push(`/codigovclean/applications/${this.vcleanCode}`);
					return;
				}
			}
  
			if (this.accordionCompetitorCodeSearchVisible) {
				if (this.competitorCode) {
					if (this.competitorCode.includes('/')) {
						this.competitorCode = this.competitorCode.replace(/\//g, '___');
					}
					if (this.competitorCode.includes(' ')) {
						this.competitorCode = this.competitorCode.replace(/ /g, ';');
					}
					this.$router.push(`/convertions/${this.competitorCode}`);
					return;
				}
			}
		},
		
		clear: function() {
			this.accordionVehicleSearchVisible = false,
			this.accordionVCleanCodeSearchVisible = false,
			this.accordionCompetitorCodeSearchVisible = false,
			this.vcleanCode = '';
			this.competitorCode = '';
			this.selectedBrand = '';
			this.selectedModel = '';
			this.selectedYear = {};
			this.brands = [];
			this.models = [];
			this.years = [];
			this.init(this.data);
		},
  
		accordionVehicleSearchShown: function() {
			this.accordionVCleanCodeSearchVisible = false;
			this.accordionCompetitorCodeSearchVisible = false;
		},
  
		accordionVCleanCodeSearchShown: function() {
			this.accordionVehicleSearchVisible = false;
			this.accordionCompetitorCodeSearchVisible = false;
		},
  
		accordionCompetitorCodeSearchShown: function() {
			this.accordionVehicleSearchVisible = false;
			this.accordionVCleanCodeSearchVisible = false;
		}
	}
};
</script>
  
<style>
	.card-body {
	padding: 0 !important;
	}
	.list-group-item {
	padding: 0.60rem 1.25rem !important;
	}
	.buttons-container {
	display: flex;
	justify-content: space-between;
	}
	.btn-block {
	padding: 1.25rem !important;
	}
	.button-search {
	width: 49.5% !important;
	padding: 1.25rem 0.75rem !important;
	background-color: #ddd !important;
	border-color: #004e64 !important;
	}
	.button-search:hover {
	background-color: #ccc !important;
	}
	.subitem {
	color: #004e64 !important;
	background-color: #f8f9fa !important;
	}
</style>
